import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { actions as statisticActions } from 'features/statistic';

import useIfInviteHidden from 'modules/App/model/useInvitePlayer/useIfInviteHidden';

import { convertFilters } from './convertFilters';

const ARGENTINA_TIMEZONE_OFFSET = -3; // Часовой пояс Аргентины (GMT -3)
const MILLISECONDS_IN_HOUR = 60 * 60 * 1000; // Количество миллисекунд в часе
const MILLISECONDS_IN_DAY = 24 * MILLISECONDS_IN_HOUR; // Количество миллисекунд в сутках
const DEFAULT_ACTIVE_TAB = 'agents'; // Вкладка по умолчанию

const useModel = () => {
  const dispatch = useDispatch();
  const ifInviteHidden = useIfInviteHidden();

  const targetUserId = useSelector(state => state.tree.targetUserId, shallowEqual);
  const authId = useSelector(state => state.auth.id, shallowEqual);

  const [activeTab, setActiveTab] = useState(DEFAULT_ACTIVE_TAB);

  const [dateRange, setDateRange] = useState({
    from: new Date(new Date().setHours(0, 0, 0, 0) - MILLISECONDS_IN_DAY), // Вчера в 00:00
    to: new Date(new Date().setHours(0, 0, 0, 0)), // Сегодня в 00:00
  });

  const onChangeFrom = useCallback(date => setDateRange(prev => ({ ...prev, from: date })), []);

  const onChangeTo = useCallback(date => setDateRange(prev => ({ ...prev, to: date })), []);

  // const adjustDateToUTC = date => {
  //   const dateCopy = new Date(date);

  //   dateCopy.setHours(0, 0, 0, 0);

  //   const utcTime = dateCopy.getTime() - ARGENTINA_TIMEZONE_OFFSET * MILLISECONDS_IN_HOUR;

  //   return new Date(utcTime);
  // };

  const fetchStatistics = useCallback(() => {
    // const fromUTC = adjustDateToUTC(dateRange.from);
    // const toUTC = adjustDateToUTC(dateRange.to);
    // toUTC.setDate(toUTC.getDate() + 1);

    const filters = convertFilters({
      // from: fromUTC,
      // to: toUTC,
      to: dateRange.to,
      from: dateRange.from,
      userId: targetUserId,
    });

    if (activeTab === 'players') {
      filters.append('is_user_ranking', 'true');
    }

    dispatch(
      statisticActions.getStatistic({
        filters,
        id: authId,
      }),
    );
  }, [dateRange.from, dateRange.to, targetUserId, activeTab, authId, dispatch]);

  useEffect(() => {
    fetchStatistics();
  }, [fetchStatistics]);

  const onSubmit = useCallback(
    e => {
      e.preventDefault();
      fetchStatistics();
    },
    [fetchStatistics],
  );

  return useMemo(
    () => ({
      inputState: {
        values: dateRange,
        activeTab,
        setActiveTab,
        onChangeFrom,
        onChangeTo,
      },
      outputState: {
        ifInviteHidden,
        onSubmit,
      },
    }),
    [dateRange, activeTab, onChangeFrom, onChangeTo, onSubmit],
  );
};

export default useModel;
